import React from "react";
import { connect } from "react-redux";
import { Accordion } from "react-bootstrap";
import { general } from "../../../../../store/action";
import { TGQuantityData } from "../../../../../types/general";
import Thermometers from "../../../../../assets/images/svgComponents/thermometers";
import ECG from "../../../../../assets/images/svgComponents/ecg";

type SummaryCardsProps = {
  spo2?: TGQuantityData;
  pulseRate?: TGQuantityData;
  bpDiastolic?: TGQuantityData;
  bpSystolic?: TGQuantityData;
  bpMean?: TGQuantityData;
  etco2?: TGQuantityData;
  fico2?: TGQuantityData;
  respiratoryRate?: TGQuantityData;
  temperature1?: TGQuantityData;
  temperature2?: TGQuantityData;
  bloodSugar?: TGQuantityData;
};

const SummaryCards = ({
  spo2,
  pulseRate,
  bpDiastolic,
  bpSystolic,
  bpMean,
  etco2,
  fico2,
  respiratoryRate,
  temperature1,
  temperature2,
  bloodSugar,
}: SummaryCardsProps) => {
  return (
    <>
      <Accordion.Header className="d-flex flex-wrap">
        <span className="font-14 me-2 text-gray font-en">
          SPO2: &ensp;
          <span className="text-black">
            {` ${spo2?.unit}`}
            {spo2?.magnitude?.toFixed(0)}
          </span>
          {/* {`  ◄►  `} */}
        </span>
        <span className="font-14 me-2 text-gray font-en">
          NIBP: &ensp;
          <span className="text-black">
            {bpSystolic?.magnitude?.toFixed(0)}
            {"/" + bpDiastolic?.magnitude?.toFixed(0)}
            {`(${
              bpMean?.magnitude != null ? bpMean.magnitude.toFixed(0) : "--"
            })`}
            {bpDiastolic?.unit}
          </span>
          {`  ►◄  `}
        </span>

        <span className="font-14 me-2 text-gray font-en">
          PR: &ensp;
          <span className="text-black">
            {pulseRate?.magnitude?.toFixed(0)} {pulseRate?.unit}
          </span>
          {`  ►◄  `}
        </span>

        <span className="font-14 me-2 text-gray font-en">
          RR: &ensp;
          <span className="text-black">
            {respiratoryRate?.magnitude?.toFixed(0)} {respiratoryRate?.unit}
          </span>
          {`  ►◄  `}
        </span>
        <div className="flex-fill"></div>
        <span className="font-14 fw-bold me-2 text-black">
          اطلاعات مربوط به علائم حیاتی
        </span>
      </Accordion.Header>
      <Accordion.Body className="rounded-bottom bg-primary-10">
        <div className="col-12 row">
          {/* SPO2 start */}
          <div className="col-lg-3 col-md-6 col-sm-12 mb-2">
            <div className="title-dot font-en mb-2">SPO2</div>
            <div className="card-box d-flex">
              <div>
                <div className="text-gray font-12">درصد اکسیژن اشباع خون</div>
                <div>
                  <span className="d-flex m-1 font-en align-items-start">
                    <div className="d-flex align-items-center">
                      <span className="bg-primary-subtle font-10 text-primary p-1 mb-2 ms-2">
                        {spo2?.unit}
                      </span>
                    </div>
                    <span className="h4 text-primary fw-bold">
                      {spo2?.magnitude?.toFixed(0)}
                    </span>
                  </span>
                </div>
              </div>
              {/* <div className="d-flex justify-content-center align-items-center me-auto">
                <ECG />
              </div> */}
            </div>
          </div>
          {/* Spo2 end */}

          {/* PR start */}
          <div className="col-lg-3 col-md-6 col-sm-12 mb-2">
            <div className="title-dot font-en mb-2">PR</div>
            <div className="card-box d-flex">
              <div>
                <div className="text-gray font-12">نبض</div>
                <div>
                  <span className="d-flex m-1 font-en align-items-start">
                    <div className="d-flex align-items-end">
                      <span className="bg-primary-subtle font-10 text-primary p-1 mb-2 ms-2">
                        {pulseRate?.unit}
                      </span>
                    </div>
                    <span className="h4 text-primary fw-bold">
                      {pulseRate?.magnitude?.toFixed(0)}
                    </span>
                  </span>
                </div>
              </div>
              {/* <div className="d-flex justify-content-center align-items-center me-auto">
                <ECG />
              </div> */}
            </div>
          </div>
          {/* PR end */}

          {/* RR start */}
          <div className="col-lg-3 col-md-6 col-sm-12 mb-2">
            <div className="title-dot font-en mb-2">RR</div>
            <div className="card-box d-flex">
              <div>
                <div className="text-gray font-12">نرخ تنفس در یک دقیقه</div>
                <div>
                  <span className="d-flex m-1 font-en align-items-start">
                    <div className="d-flex align-items-end">
                      <span className="bg-primary-subtle font-10 text-primary p-1 mb-2 ms-2">
                        {respiratoryRate?.unit}
                      </span>
                    </div>
                    <span className="h4 text-primary fw-bold">
                      {respiratoryRate?.magnitude?.toFixed(0)}
                    </span>
                  </span>
                </div>
              </div>
              {/* <div className="d-flex justify-content-center align-items-center me-auto">
                <ECG />
              </div> */}
            </div>
          </div>
          {/* RR end */}

          {/* NIBP start */}
          <div className="col-lg-3 col-md-6 col-sm-12 mb-2">
            <div className="title-dot font-en mb-2">NIBP</div>
            <div className="card-box d-flex">
              <div>
                <div className="text-gray font-12">میزان فشار خون</div>
                <div>
                  <span className="d-flex m-1 font-en align-items-start">
                    <div className="d-flex align-items-end">
                      <span className="bg-primary-subtle font-10 text-primary p-1 mb-2 ms-2">
                        ({bpDiastolic?.unit})
                      </span>
                    </div>
                    <span className="h4 text-primary fw-bold">
                      {`(${
                        bpMean?.magnitude != null
                          ? bpMean.magnitude.toFixed(0)
                          : "--"
                      })`}
                      {bpSystolic?.magnitude?.toFixed(0)}/
                      {bpDiastolic?.magnitude?.toFixed(0)}
                    </span>
                  </span>
                </div>
              </div>
              {/* <div className="d-flex justify-content-center align-items-center me-auto">
                <ECG />
              </div> */}
            </div>
          </div>
          {/* NIBP end */}

          {/* Temp1 start */}
          <div className="col-lg-3 col-md-6 col-sm-12 mb-2">
            <div className="title-dot font-en mb-2">Temp 1</div>
            <div className="card-box d-flex">
              <div>
                <div className="text-gray font-12">میزان دمای طبیعی بدن</div>
                <div>
                  <span className="d-flex m-1 font-en align-items-start">
                    <div className="d-flex align-items-end">
                      <span className="bg-primary-subtle font-10 text-primary p-1 mb-2 ms-2">
                        ({temperature1?.unit})
                      </span>
                    </div>
                    <span className="h4 text-primary fw-bold">
                      {temperature1?.magnitude?.toFixed(1)}
                    </span>
                  </span>
                </div>
              </div>
              {/* <div className="d-flex justify-content-center align-items-center me-auto">
                <Thermometers />
              </div> */}
            </div>
          </div>
          {/* Temp1 end */}

          {/* Temp2 start */}
          <div className="col-lg-3 col-md-6 col-sm-12 mb-2">
            <div className="title-dot font-en mb-2">Temp 2</div>
            <div className="card-box d-flex">
              <div>
                <div className="text-gray font-12">میزان دمای طبیعی بدن</div>
                <div>
                  <span className="d-flex m-1 font-en align-items-start">
                    <div className="d-flex align-items-end">
                      <span className="bg-primary-subtle font-10 text-primary p-1 mb-2 ms-2">
                        ({temperature2?.unit})
                      </span>
                    </div>
                    <span className="h4 text-primary fw-bold">
                      {temperature2?.magnitude?.toFixed(1)}
                    </span>
                  </span>
                </div>
              </div>
              {/* <div className="d-flex justify-content-center align-items-center me-auto">
                <Thermometers />
              </div> */}
            </div>
          </div>
          {/* Temp2 end */}

          {/* FICO2 start */}
          <div className="col-lg-3 col-md-6 col-sm-12 mb-2">
            <div className="title-dot font-en mb-2">FICO2</div>
            <div className="card-box d-flex">
              <div>
                <div className="text-gray font-12">
                  میزان گاز دی‌اکسیدکربن در دم
                </div>
                <div>
                  <span className="d-flex m-1 font-en align-items-start">
                    <div className="d-flex align-items-end">
                      <span className="bg-primary-subtle font-10 text-primary p-1 mb-2 ms-2">
                        {fico2?.unit}
                      </span>
                    </div>
                    <span className="h4 text-primary fw-bold">
                      {fico2?.magnitude?.toFixed(1)}
                    </span>
                  </span>
                </div>
              </div>
              {/* <div className="d-flex justify-content-center align-items-center me-auto">
                <ECG />
              </div> */}
            </div>
          </div>

          {/* ETCO2 start */}
          <div className="col-lg-3 col-md-6 col-sm-12 mb-2">
            <div className="title-dot font-en mb-2">ETCO2</div>
            <div className="card-box d-flex">
              <div>
                <div className="text-gray font-12">
                  میزان گاز دی‌اکسیدکربن در بازدم
                </div>
                <div>
                  <span className="d-flex m-1 font-en align-items-start">
                    <div className="d-flex align-items-end">
                      <span className="bg-primary-subtle font-10 text-primary p-1 mb-2 ms-2">
                        {etco2?.unit}
                      </span>
                    </div>
                    <span className="h4 text-primary fw-bold">
                      {etco2?.magnitude?.toFixed(1)}
                    </span>
                  </span>
                </div>
              </div>
              {/* <div className="d-flex justify-content-center align-items-center me-auto">
                <ECG />
              </div> */}
            </div>
          </div>
          {/* ETCO2 end */}

          {/* FICO2 end */}
          {/* BS start */}
          <div className="col-lg-3 col-md-6 col-sm-12 mb-2">
            <div className="title-dot font-en mb-2">BS</div>
            <div className="card-box d-flex">
              <div>
                <div className="text-gray font-12">میزان قند خون</div>
                <div>
                  <span className="d-flex m-1 font-en align-items-start">
                    <div className="d-flex align-items-end">
                      <span className="bg-primary-subtle font-10 text-primary p-1 mb-2 ms-2">
                        {/* ({BS?.unit}) */}
                        (mg/dL)
                      </span>
                    </div>
                    <span className="h4 text-primary fw-bold">
                      {/* {BS?.magnitude?.toFixed(1)} */}
                      {`${
                        bloodSugar?.magnitude != null
                          ? bloodSugar.magnitude.toFixed(0)
                          : "---"
                      }`}
                    </span>
                  </span>
                </div>
              </div>
              {/* <div className="d-flex justify-content-center align-items-center me-auto">
                <Thermometers />
              </div> */}
            </div>
          </div>
          {/* BS end */}
        </div>
      </Accordion.Body>
    </>
  );
};

const mapDispatchToProps = (dispatch: any) => ({
  handleShowModal: (data: any, body: any) =>
    dispatch(general.handleShowModal(data, body)),
});

export default connect(null, mapDispatchToProps)(SummaryCards);
